/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Pre_Render_Frame_Cache_Failed_StatusInputs */



/**
* | output |
* | --- |
* | "Cannot generate frame cache: {error}" |
*
* @param {Pre_Render_Frame_Cache_Failed_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const pre_render_frame_cache_failed_status = /** @type {((inputs: Pre_Render_Frame_Cache_Failed_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pre_Render_Frame_Cache_Failed_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Impossible de générer le cache d'images : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Frame-Cache konnte nicht generiert werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile generare la cache dei frame: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось создать кэш кадров: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se puede generar la caché de fotogramas: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`无法生成帧缓存：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`フレームキャッシュを生成できません: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`फ्रेम कैश उत्पन्न नहीं किया जा सकता: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Não foi possível gerar o cache de quadros: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Cannot generate frame cache: ${i?.error}`)
});